export const parseIntParams = (propMap, keys) => {
  keys.forEach(key => {
    const recordValue = propMap.get(key);
    if (recordValue) {
      /* eslint-disable-next-line radix */
      const parsedInt = parseInt(recordValue, 0);
      if (!isNaN(parsedInt)) propMap = propMap.set(key, parsedInt);
    }
  });
  return propMap;
};